module.exports = __webpack_public_path__ + "img/culture-banner-sp.6e0bf9a8.jpg";